export default {
    ReviewSectionRating: {
        rating: "Rating text-white relative inline-block",
        star:"mr-6"
    },
    HeroSectionRating: {
        rating: "HeroRating text-darkGrey relative",
        star:"mr-6"
    },
    BaseRating: {
        topStar: "topStar absolute top-0 left-0 overflow-hidden",
        bottomStar: "bottomStar"
    }
}